import { z } from 'zod';
import type { TFunction } from 'i18next';

// Slug catalogs are dynamic (backend-driven). Required slugs are validated as
// non-empty strings; optional slug fields accept empty string. Authoritative
// validation lives in the backend.
export function createSimulationSchema(t: TFunction) {
  return z.object({
    name: z
      .string()
      .min(3, t('validation.sim_name_min'))
      .max(100, t('validation.sim_name_max')),
    simulationType: z
      .string()
      .min(1, t('validation.sim_type_required')),
    salePhase: z
      .string()
      .min(1, t('validation.sim_phase_required')),
    objections: z.string().optional(),
    sector: z.string().optional(),
    subSector: z.string().optional(),
    priceRange: z.string().optional(),
    difficultyLevel: z.number().min(1).max(5),
    assignedMaestroId: z.string().optional(),
    assignedSalespersonIds: z.array(z.string()).optional(),
    purpose: z.enum(['evaluate', 'pitch']).optional(),
    pitchObjective: z.string().max(2000).optional(),
    kpisToEvaluate: z.array(z.string()).optional(),
    language: z.enum(['es', 'it']),
  });
}

export type SimulationFormValues = z.infer<ReturnType<typeof createSimulationSchema>>;
